import { Ref, computed, inject, provide } from "vue";
import { AdTag } from "../types/index";

export function createBrand(adtagData: Ref<AdTag>) {
  const adTemplate = computed(() => adtagData.value.brand.adTemplate);
  const brand = computed(() => adtagData.value.brand);
  const buttons = computed(() => adtagData.value.brand.buttons);
  const fonts = computed(() => adtagData.value.brand.fonts);
  const colors = computed(() => adtagData.value.brand.colors);

  const getColor = (colorKey: string) => colors.value?.[colorKey]?.color;

  const getFont = (fontKey: string) => ({
    fontFamily: fonts.value[fontKey].fontAsset.fontFamily,
    color: getColor(fonts.value[fontKey].color) || ""
  });

  function getActionColors(action) {
    return {
      color: getColor(action.color),
      backgroundColor: getColor(action.backgroundColor),
      borderColor: getColor(action.borderColor)
    };
  }

  const getButton = (buttonKey: string) => {
    const button = buttons.value[buttonKey];

    return {
      ...button,
      primaryFont: getFont(button.primaryFont || ""),
      secondaryFont: getFont(button.secondaryFont || ""),
      backgroundColor: getColor(button.backgroundColor || ""),
      borderColor: getColor(button.borderColor || ""),
      hover: button?.actions.hover
        ? getActionColors(button.actions.hover)
        : undefined,
      active: button?.actions.active
        ? getActionColors(button.actions.active)
        : undefined
    };
  };

  return {
    adTemplate,
    brand,
    getButton
  };
}

type Brand = ReturnType<typeof createBrand>;

export const brandSymbol = Symbol("brandSymbol");

export function provideBrand(adtagData: Ref<AdTag>) {
  provide(brandSymbol, createBrand(adtagData));
}

export function injectBrand() {
  return inject<Brand>(brandSymbol);
}
